import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WrenchIcon, ZapIcon, ThermometerIcon, HomeIcon, PaintbrushIcon, SparklesIcon, TreesIcon, BugIcon, ShowerHeadIcon, BathIcon, ArrowUpIcon, SquareIcon, SunIcon, CookingPotIcon, LayersIcon, DoorOpenIcon, WarehouseIcon, ShieldIcon, FenceIcon, SnowflakeIcon, FootprintsIcon } from 'lucide-react';
import { pxFormConfigs } from '../data/pxFormConfigs';
interface PopularServicesProps {
  onServiceClick?: (serviceSlug: string) => void;
}
export function PopularServices({
  onServiceClick
}: PopularServicesProps) {
  const allServices = [{
    name: 'Walk-In Showers',
    slug: 'walk-in-showers',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-1076" />
  }, {
    name: 'Walk-In Tubs',
    slug: 'walk-in-tubs',
    icon: <BathIcon className="w-6 h-6" data-id="element-1077" />
  }, {
    name: 'Stairlifts',
    slug: 'stairlifts',
    icon: <ArrowUpIcon className="w-6 h-6" data-id="element-1078" />
  }, {
    name: 'Window Replacement',
    slug: 'window-replacement',
    icon: <SquareIcon className="w-6 h-6" data-id="element-1079" />
  }, {
    name: 'Gutter Guards',
    slug: 'gutter-guards',
    icon: <LayersIcon className="w-6 h-6" data-id="element-1080" />
  }, {
    name: 'Roofing',
    slug: 'roofing',
    icon: <HomeIcon className="w-6 h-6" data-id="element-1081" />
  }, {
    name: 'Siding',
    slug: 'siding',
    icon: <HomeIcon className="w-6 h-6" data-id="element-1082" />
  }, {
    name: 'Solar Panels',
    slug: 'solar',
    icon: <SunIcon className="w-6 h-6" data-id="element-1083" />
  }, {
    name: 'Bathroom Remodel',
    slug: 'bathroom-remodel',
    icon: <ShowerHeadIcon className="w-6 h-6" data-id="element-1084" />
  }, {
    name: 'Kitchen Remodel',
    slug: 'kitchen-remodel',
    icon: <CookingPotIcon className="w-6 h-6" data-id="element-1085" />
  }, {
    name: 'Flooring',
    slug: 'flooring',
    icon: <FootprintsIcon className="w-6 h-6" data-id="element-1086" />
  }, {
    name: 'HVAC',
    slug: 'hvac',
    icon: <ThermometerIcon className="w-6 h-6" data-id="element-1087" />
  }, {
    name: 'Painting',
    slug: 'painting',
    icon: <PaintbrushIcon className="w-6 h-6" data-id="element-1088" />
  }, {
    name: 'Plumbing',
    slug: 'plumbing',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-1089" />
  }, {
    name: 'Electrical',
    slug: 'electrical',
    icon: <ZapIcon className="w-6 h-6" data-id="element-1090" />
  }, {
    name: 'Fencing',
    slug: 'fencing',
    icon: <FenceIcon className="w-6 h-6" data-id="element-1091" />
  }, {
    name: 'Insulation',
    slug: 'insulation',
    icon: <SnowflakeIcon className="w-6 h-6" data-id="element-1092" />
  }, {
    name: 'Doors',
    slug: 'doors',
    icon: <DoorOpenIcon className="w-6 h-6" data-id="element-1093" />
  }, {
    name: 'Garage Doors',
    slug: 'garage-doors',
    icon: <WarehouseIcon className="w-6 h-6" data-id="element-1094" />
  }, {
    name: 'Home Security',
    slug: 'home-security',
    icon: <ShieldIcon className="w-6 h-6" data-id="element-1095" />
  }, {
    name: 'Pest Control',
    slug: 'pest-control',
    icon: <BugIcon className="w-6 h-6" data-id="element-1096" />
  }, {
    name: 'Landscaping',
    slug: 'landscaping',
    icon: <TreesIcon className="w-6 h-6" data-id="element-1097" />
  }, {
    name: 'Cleaning',
    slug: 'cleaning',
    icon: <SparklesIcon className="w-6 h-6" data-id="element-1098" />
  }, {
    name: 'General Repair',
    slug: 'general',
    icon: <WrenchIcon className="w-6 h-6" data-id="element-1099" />
  }];
  // Separate services into active (has PX config or dedicated form) and coming soon
  const activeServices = allServices.filter(s => pxFormConfigs[s.slug] || s.slug === 'window-replacement' || s.slug === 'roofing');
  const comingSoonServices = allServices.filter(s => !pxFormConfigs[s.slug] && s.slug !== 'window-replacement' && s.slug !== 'roofing');
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 10
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4
      }
    }
  };
  return <section id="services" className="py-20 bg-slate-50" data-id="element-1100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1101">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4" data-id="element-1102">
          <div data-id="element-1103">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-1104">
              Home Improvement Projects
            </h2>
            <p className="text-lg text-slate-600" data-id="element-1105">
              Browse our available service categories
            </p>
          </div>
        </div>

        <motion.div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} data-id="element-1106">
          {activeServices.map((service, index) => <motion.button key={index} variants={itemVariants} onClick={() => onServiceClick?.(service.slug)} className="group flex flex-col p-6 bg-white rounded-xl border border-slate-200 shadow-sm hover:shadow-md hover:border-amber-200 hover:-translate-y-1 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-amber-500 items-center justify-start cursor-pointer" data-id="element-1107">
              <div className="w-12 h-12 rounded-lg text-slate-700 group-hover:bg-amber-50 group-hover:text-amber-600 flex items-center justify-center mb-4 transition-colors bg-[#F59E0B]" data-id="element-1108">
                {service.icon}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2 text-center" data-id="element-1109">
                {service.name}
              </h3>
              <span className="text-sm font-medium text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1" data-id="element-1110">
                Get Quotes <span aria-hidden="true" data-id="element-1111">&rarr;</span>
              </span>
            </motion.button>)}
        </motion.div>

        {comingSoonServices.length > 0 && <div className="mt-20" data-id="element-1112">
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4" data-id="element-1113">
              <div data-id="element-1114">
                <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-1115">
                  Coming Soon
                </h3>
                <p className="text-slate-500" data-id="element-1116">
                  We're working on adding more service categories to our network
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5 opacity-60 grayscale-[50%]" data-id="element-1117">
              {comingSoonServices.map((service, index) => <div key={index} className="flex flex-col p-6 bg-slate-50 rounded-xl border border-slate-200 items-center justify-start cursor-not-allowed" data-id="element-1118">
                  <div className="w-12 h-12 rounded-lg text-slate-400 bg-slate-200 flex items-center justify-center mb-4" data-id="element-1119">
                    {service.icon}
                  </div>
                  <h3 className="text-sm font-semibold text-slate-600 mb-2 text-center" data-id="element-1120">
                    {service.name}
                  </h3>
                  <span className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-1121">
                    Coming Soon
                  </span>
                </div>)}
            </div>
          </div>}
      </div>
    </section>;
}